import type { TableSemanticSchema } from './types';

export const RaciSchema: TableSemanticSchema = {
  id: 'raci',
  name: 'RACI Matrix',
  description:
    'Task-by-role responsibility matrix. Cells carry the RACI code (Responsible/Accountable/Consulted/Informed) for each intersection.',
  cells: [],
  itemFields: [
    { key: 'taskId', label: 'Task', kind: 'id', required: true },
    { key: 'roleId', label: 'Role', kind: 'id', required: true },
    { key: 'responsibilityType', label: 'Responsibility', kind: 'enum', required: true,
      options: [
        { value: 'R', label: 'Responsible' },
        { value: 'A', label: 'Accountable' },
        { value: 'C', label: 'Consulted' },
        { value: 'I', label: 'Informed' },
      ] },
    { key: 'notes', label: 'Notes', kind: 'string' },
  ],
  renderingHints: {
    layout: 'grid',
    cellColors: {
      R: '#bbf7d0',
      A: '#fde68a',
      C: '#bfdbfe',
      I: '#e9d5ff',
    },
  },
};
